import axios, { AxiosError } from "axios"
import { Dispatch } from "react"
import { RNBThunkAction } from "../store.config"
import { allTime } from "../../utils/treasury"

export const enum TreasuryActionEnum {
  GET_TREASURY_MERCHANTS_ATTEMPT = "TREASURY/getTreasuryMerchantsAttempt",
  GET_TREASURY_MERCHANTS_SUCCESS = "TREASURY/getTreasuryMerchantsSuccess",
  GET_TREASURY_MERCHANTS_FAILURE = "TREASURY/getTreasuryMerchantsFailure",
  CHANGE_MERCHANT_TREASURY_SETTINGS_ATTEMPT = "TREASURY/changeMerchantTreasurySettingsAttempt",
  CHANGE_MERCHANT_TREASURY_SETTINGS_SUCCESS = "TREASURY/changeMerchantTreasurySettingsSuccess",
  CHANGE_MERCHANT_TREASURY_SETTINGS_FAILURE = "TREASURY/changeMerchantTreasurySettingsFailure",
  GET_BUY_FULL_DOCUMENTS_ATTEMPT = "TREASURY/getTreasuryFullDocumentsAttemptAttempt",
  GET_BUY_FULL_DOCUMENTS_SUCCESS = "TREASURY/getTreasuryFullDocumentsSuccessSuccess",
  GET_BUY_FULL_DOCUMENTS_FAILURE = "TREASURY/getTreasuryFullDocumentsFailureFailure",
  UPDATE_FULL_DOCUMENTS_PAYMENT_STATUS_ATTEMPT = "TREASURY/updateFullDocumentPaymentStatusAttempt",
  UPDATE_FULL_DOCUMENTS_PAYMENT_STATUS_SUCCESS = "TREASURY/updateFullDocumentPaymentStatusSuccess",
  UPDATE_FULL_DOCUMENTS_PAYMENT_STATUS_FAILURE = "TREASURY/updateFullDocumentPaymentStatusFailure",
  ASK_FOR_VALIDATION_ATTEMPT = "TREASURY/askForValidationAttempt",
  ASK_FOR_VALIDATION_SUCCESS = "TREASURY/askForValidationSuccess",
  ASK_FOR_VALIDATION_FAILURE = "TREASURY/askForValidationFailure",
  GET_USERS_AVAILAIBLE_FOR_VALIDATION_ATTEMPT = "TREASURY/getUsersAvailableForValidationAttempt",
  GET_USERS_AVAILAIBLE_FOR_VALIDATION_SUCCESS = "TREASURY/getUsersAvailableForValidationSuccess",
  GET_USERS_AVAILAIBLE_FOR_VALIDATION_FAILURE = "TREASURY/getUsersAvailableForValidationFailure",
  GET_TREASURY_FULL_DOCUMENT_HISTORY_ATTEMPT = "TREASURY/getTreasuryFullDocumentHistoryAttempt",
  GET_TREASURY_FULL_DOCUMENT_HISTORY_SUCCESS = "TREASURY/getTreasuryFullDocumentHistorySuccess",
  GET_TREASURY_FULL_DOCUMENT_HISTORY_FAILURE = "TREASURY/getTreasuryFullDocumentHistoryFailure",
  GET_TREASURY_FULL_DOCUMENT_HISTORY_RESET = "TREASURY/getTreasuryFullDocumentHistoryReset",
  GET_TREASURY_MERCHANT_HISTORY_ATTEMPT = "TREASURY/getTreasuryMerchantHistoryAttempt",
  GET_TREASURY_MERCHANT_HISTORY_SUCCESS = "TREASURY/getTreasuryMerchantHistorySuccess",
  GET_TREASURY_MERCHANT_HISTORY_FAILURE = "TREASURY/getTreasuryMerchantHistoryFailure",
  GET_TREASURY_MERCHANT_HISTORY_RESET = "TREASURY/getTreasuryMerchantHistoryReset",
  SET_DATE_RANGE = "TREASURY/setDateRange",
  SET_PA_FLOW_FILTER = "TREASURY/setPaFlowFilter",
  PAY_FULL_DOCUMENT_ATTEMPT = "TREASURY/payFullDocumentAttempt",
  PAY_FULL_DOCUMENT_SUCCESS = "TREASURY/payFullDocumentSuccess",
  PAY_FULL_DOCUMENT_FAILURE = "TREASURY/payFullDocumentFailure",
  GET_TREASURY_BANK_PARAMETERS_ATTEMPT = "TREASURY/getTreasuryBankParametersAttempt",
  GET_TREASURY_BANK_PARAMETERS_SUCCESS = "TREASURY/getTreasuryBankParametersSuccess",
  GET_TREASURY_BANK_PARAMETERS_FAILURE = "TREASURY/getTreasuryBankParametersFailure",
  TREASURY_CREATE_BANK_PARAMETERS_RESET = "TREASURY/treasuryCreateBankParametersReset",
  TREASURY_CREATE_BANK_PARAMETERS_ATTEMPT = "TREASURY/treasuryCreateBankParametersAttempt",
  TREASURY_CREATE_BANK_PARAMETERS_SUCCESS = "TREASURY/treasuryCreateBankParametersSuccess",
  TREASURY_CREATE_BANK_PARAMETERS_FAILURE = "TREASURY/treasuryCreateBankParametersFailure",
  TREASURY_DELETE_BANK_PARAMETERS_ATTEMPT = "TREASURY/treasuryDeleteBankParametersAttempt",
  TREASURY_DELETE_BANK_PARAMETERS_SUCCESS = "TREASURY/treasuryDeleteBankParametersSuccess",
  TREASURY_DELETE_BANK_PARAMETERS_FAILURE = "TREASURY/treasuryDeleteBankParametersFailure",
}

export const getTreasuryMerchantsAttempt = () =>
  ({ type: TreasuryActionEnum.GET_TREASURY_MERCHANTS_ATTEMPT } as const)
export const getTreasuryMerchantsSuccess = (payload: TreasuryMerchants[]) =>
  ({
    type: TreasuryActionEnum.GET_TREASURY_MERCHANTS_SUCCESS,
    payload,
  } as const)
export const getTreasuryMerchantsFailure = () =>
  ({ type: TreasuryActionEnum.GET_TREASURY_MERCHANTS_FAILURE } as const)
export const changeMerchantTreasurySettingsAttempt = () =>
  ({
    type: TreasuryActionEnum.CHANGE_MERCHANT_TREASURY_SETTINGS_ATTEMPT,
  } as const)
export const changeMerchantTreasurySettingsSuccess = () =>
  ({
    type: TreasuryActionEnum.CHANGE_MERCHANT_TREASURY_SETTINGS_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "treasury.change_merchant_treasury_settings.header.success",
      bodyKey: "treasury.change_merchant_treasury_settings.body.success",
    },
  } as const)
export const changeMerchantTreasurySettingsFailure = (payload: AxiosError) =>
  ({
    type: TreasuryActionEnum.CHANGE_MERCHANT_TREASURY_SETTINGS_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `treasury.change_merchant_treasury_settings.header.failure`,
      bodyKey: `treasury.change_merchant_treasury_settings.body.failure.${payload}`,
    },
  } as const)
export const getTreasuryFullDocumentsAttempt = () =>
  ({ type: TreasuryActionEnum.GET_BUY_FULL_DOCUMENTS_ATTEMPT } as const)
export const getTreasuryFullDocumentsSuccess = (
  payload: getTreasuryFullDocumentsResponse
) =>
  ({
    type: TreasuryActionEnum.GET_BUY_FULL_DOCUMENTS_SUCCESS,
    payload,
  } as const)
export const getTreasuryFullDocumentsFailure = () =>
  ({ type: TreasuryActionEnum.GET_BUY_FULL_DOCUMENTS_FAILURE } as const)
export const updateFullDocumentPaymentStatusAttempt = () =>
  ({
    type: TreasuryActionEnum.UPDATE_FULL_DOCUMENTS_PAYMENT_STATUS_ATTEMPT,
  } as const)
export const updateFullDocumentPaymentStatusSuccess = () =>
  ({
    type: TreasuryActionEnum.UPDATE_FULL_DOCUMENTS_PAYMENT_STATUS_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `treasury.update_full_document_payment_status.success.title`,
      bodyKey: `treasury.update_full_document_payment_status.success.body`,
    },
  } as const)
export const updateFullDocumentPaymentStatusFailure = (
  payload: AxiosError,
  actionType: FullDocumentPaymentActionType
) =>
  ({
    type: TreasuryActionEnum.UPDATE_FULL_DOCUMENTS_PAYMENT_STATUS_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `treasury.failure.${actionType}.header`,
      bodyKey: `treasury.buy.update_full_document_payment_status.body.failure.${payload}`,
    },
  } as const)
export const askForValidationAttempt = () =>
  ({ type: TreasuryActionEnum.ASK_FOR_VALIDATION_ATTEMPT } as const)
export const askForValidationSuccess = () =>
  ({
    type: TreasuryActionEnum.ASK_FOR_VALIDATION_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `treasury.buy.to-control.ask-validation.header.success`,
      bodyKey: `treasury.buy.to-control.ask-validation.body.success`,
    },
  } as const)
export const askForValidationFailure = (payload: AxiosError) =>
  ({
    type: TreasuryActionEnum.ASK_FOR_VALIDATION_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `treasury.buy.to-control.ask-validation.header.failure`,
      bodyKey: `treasury.buy.to-control.ask-validation.body.failure.${payload}`,
    },
  } as const)
export const getUsersAvailableForValidationAttempt = () =>
  ({
    type: TreasuryActionEnum.GET_USERS_AVAILAIBLE_FOR_VALIDATION_ATTEMPT,
  } as const)
export const getUsersAvailableForValidationSuccess = (
  payload: UsersAvailableForValidation[]
) =>
  ({
    type: TreasuryActionEnum.GET_USERS_AVAILAIBLE_FOR_VALIDATION_SUCCESS,
    payload,
  } as const)
export const getUsersAvailableForValidationFailure = () =>
  ({
    type: TreasuryActionEnum.GET_USERS_AVAILAIBLE_FOR_VALIDATION_FAILURE,
  } as const)
export const getTreasuryFullDocumentHistorySuccess = (
  payload: TreasuryFullDocumentHistory[]
) =>
  ({
    type: TreasuryActionEnum.GET_TREASURY_FULL_DOCUMENT_HISTORY_SUCCESS,
    payload,
  } as const)
export const getTreasuryFullDocumentHistoryFailure = () =>
  ({
    type: TreasuryActionEnum.GET_TREASURY_FULL_DOCUMENT_HISTORY_FAILURE,
  } as const)
export const getTreasuryFullDocumentHistoryAttempt = () =>
  ({
    type: TreasuryActionEnum.GET_TREASURY_FULL_DOCUMENT_HISTORY_ATTEMPT,
  } as const)
export const getTreasuryFullDocumentHistoryReset = () =>
  ({
    type: TreasuryActionEnum.GET_TREASURY_FULL_DOCUMENT_HISTORY_RESET,
  } as const)
export const getTreasuryMerchantHistoryAttempt = () =>
  ({ type: TreasuryActionEnum.GET_TREASURY_MERCHANT_HISTORY_ATTEMPT } as const)
export const getTreasuryMerchantHistorySuccess = (
  payload: TreasuryMerchantHistory[]
) =>
  ({
    type: TreasuryActionEnum.GET_TREASURY_MERCHANT_HISTORY_SUCCESS,
    payload,
  } as const)
export const getTreasuryMerchantHistoryFailure = () =>
  ({ type: TreasuryActionEnum.GET_TREASURY_MERCHANT_HISTORY_FAILURE } as const)
export const getTreasuryMerchantHistoryReset = () =>
  ({ type: TreasuryActionEnum.GET_TREASURY_MERCHANT_HISTORY_RESET } as const)
export const setDateRange = (payload: [Date, Date] | null) =>
  ({ type: TreasuryActionEnum.SET_DATE_RANGE, payload } as const)
export const setPaFlowFilter = (payload: boolean) =>
  ({ type: TreasuryActionEnum.SET_PA_FLOW_FILTER, payload } as const)

export const payFullDocumentAttempt = (full_document_id: number) =>
  ({
    type: TreasuryActionEnum.PAY_FULL_DOCUMENT_ATTEMPT,
    payload: full_document_id,
  } as const)
export const payFullDocumentSuccess = (payload: string) =>
  ({
    type: TreasuryActionEnum.PAY_FULL_DOCUMENT_SUCCESS,
    payload,
  } as const)
export const payFullDocumentFailure = () =>
  ({ type: TreasuryActionEnum.PAY_FULL_DOCUMENT_FAILURE } as const)

export const getTreasuryBankParametersAttempt = () =>
  ({ type: TreasuryActionEnum.GET_TREASURY_BANK_PARAMETERS_ATTEMPT } as const)
export const getTreasuryBankParametersSuccess = (payload: BankParameter[]) =>
  ({
    type: TreasuryActionEnum.GET_TREASURY_BANK_PARAMETERS_SUCCESS,
    payload,
  } as const)
export const getTreasuryBankParametersFailure = () =>
  ({ type: TreasuryActionEnum.GET_TREASURY_BANK_PARAMETERS_FAILURE } as const)

export const treasuryCreateBankParametersReset = () =>
  ({
    type: TreasuryActionEnum.TREASURY_CREATE_BANK_PARAMETERS_RESET,
  } as const)
export const treasuryCreateBankParametersAttempt = () =>
  ({
    type: TreasuryActionEnum.TREASURY_CREATE_BANK_PARAMETERS_ATTEMPT,
  } as const)
export const treasuryCreateBankParametersSuccess = () =>
  ({
    type: TreasuryActionEnum.TREASURY_CREATE_BANK_PARAMETERS_SUCCESS,
  } as const)
export const treasuryCreateBankParametersFailure = () =>
  ({
    type: TreasuryActionEnum.TREASURY_CREATE_BANK_PARAMETERS_FAILURE,
  } as const)

export const treasuryDeleteBankParametersAttempt = () =>
  ({
    type: TreasuryActionEnum.TREASURY_DELETE_BANK_PARAMETERS_ATTEMPT,
  } as const)
export const treasuryDeleteBankParametersSuccess = () =>
  ({
    type: TreasuryActionEnum.TREASURY_DELETE_BANK_PARAMETERS_SUCCESS,
  } as const)
export const treasuryDeleteBankParametersFailure = () =>
  ({
    type: TreasuryActionEnum.TREASURY_DELETE_BANK_PARAMETERS_FAILURE,
  } as const)
type TreasuryActionsType = ReturnType<
  | typeof getTreasuryMerchantsAttempt
  | typeof getTreasuryMerchantsSuccess
  | typeof getTreasuryMerchantsFailure
  | typeof changeMerchantTreasurySettingsAttempt
  | typeof changeMerchantTreasurySettingsSuccess
  | typeof changeMerchantTreasurySettingsFailure
  | typeof getTreasuryFullDocumentsAttempt
  | typeof getTreasuryFullDocumentsSuccess
  | typeof getTreasuryFullDocumentsFailure
  | typeof updateFullDocumentPaymentStatusAttempt
  | typeof updateFullDocumentPaymentStatusSuccess
  | typeof updateFullDocumentPaymentStatusFailure
  | typeof askForValidationAttempt
  | typeof askForValidationSuccess
  | typeof askForValidationFailure
  | typeof getUsersAvailableForValidationAttempt
  | typeof getUsersAvailableForValidationSuccess
  | typeof getUsersAvailableForValidationFailure
  | typeof getTreasuryFullDocumentHistoryAttempt
  | typeof getTreasuryFullDocumentHistorySuccess
  | typeof getTreasuryFullDocumentHistoryFailure
  | typeof getTreasuryFullDocumentHistoryReset
  | typeof getTreasuryMerchantHistoryAttempt
  | typeof getTreasuryMerchantHistorySuccess
  | typeof getTreasuryMerchantHistoryFailure
  | typeof getTreasuryMerchantHistoryReset
  | typeof setDateRange
  | typeof setPaFlowFilter
  | typeof payFullDocumentAttempt
  | typeof payFullDocumentSuccess
  | typeof payFullDocumentFailure
  | typeof getTreasuryBankParametersAttempt
  | typeof getTreasuryBankParametersSuccess
  | typeof getTreasuryBankParametersFailure
  | typeof treasuryCreateBankParametersReset
  | typeof treasuryCreateBankParametersAttempt
  | typeof treasuryCreateBankParametersSuccess
  | typeof treasuryCreateBankParametersFailure
  | typeof treasuryDeleteBankParametersAttempt
  | typeof treasuryDeleteBankParametersSuccess
  | typeof treasuryDeleteBankParametersFailure
>

export type PaymentStatus =
  | "to_control"
  | "to_pay"
  | "paid"
  | "rejected"
  | "to_receive"
  | "received"
  | "irrecoverable"

export type TreasuryUserMerchantInstructionType =
  | "validate_directly"
  | "mark_as_paid_directly"

export type FullDocumentPaymentActionType =
  | "validate"
  | "mark_as_paid"
  | "reject"
  | "mark_as_to_control"
  | "mark_as_irrecoverable"
  | "mark_as_payment_received"
  | "mark_as_to_receive"
  | "mark_as_received"

export type BuyPaymentStatus = "to_control" | "to_pay" | "paid" | "rejected"
export type SellPaymentStatus = "to_receive" | "received" | "irrecoverable"

export interface getTreasuryMerchantResponse {
  merchants: TreasuryMerchants[]
}

export interface TreasuryMerchants {
  id: number
  name: string
  validate_directly: boolean
  mark_as_paid_directly: boolean
}

export interface TreasuryFullDocuments {
  id: number
  document_type: "invoice" | "credit_note"
  document_reference: string
  document_date: string
  document_due_date: string
  user_file_name: string
  file_name: string
  buy_or_sell: "buy" | "sell"
  merchant_name: string
  amount_tax_excluded: number | null
  amount_tax_included: number | null
  validation_request: number | null
  dropped_by_pa_flow?: boolean
}

export interface DashBoardFullDocuments {
  to_control: TreasuryFullDocuments[]
  to_pay: TreasuryFullDocuments[]
  paid: TreasuryFullDocuments[]
  rejected: TreasuryFullDocuments[]
  to_receive: TreasuryFullDocuments[]
  received: TreasuryFullDocuments[]
  irrecoverable: TreasuryFullDocuments[]
}

export interface TreasuryMerchantHistory {
  merchant_id: number
  metadata: {
    validate_directly: boolean
    mark_as_paid_directly: boolean
  }
  instruction_type: TreasuryUserMerchantInstructionType
  created_at: string
  user_email: string
}

export interface UsersAvailableForValidation {
  id: number
  email: string
}

export interface ValidatioNRequest {
  id: number
  full_document_id: number
  request_user_id: number
  requested_user_id: number
  created_at: string
}

// Le back ne renvoie que les statuts ayant au moins un document (GROUP BY)
export interface getTreasuryFullDocumentsResponse {
  dashboard: Partial<DashBoardFullDocuments>
}

export interface TreasuryFullDocumentHistory {
  id: number
  full_document_id: number
  user_id: number
  user_email: string
  event_type: FullDocumentPaymentActionType
  created_at: string
  updated_at: string
}

export interface TreasuryState {
  merchants: TreasuryMerchants[]
  dashboard: DashBoardFullDocuments
  user_available_for_validation: UsersAvailableForValidation[]
  full_document_history: TreasuryFullDocumentHistory[]
  merchant_history: TreasuryMerchantHistory[]
  range: [Date, Date]
  paymentLinkStatus: "idle" | "loading" | "success" | "failure"
  paymentLinkFullDocumentId: number | null
  paymentLinkUrl: string | null
  bankParameters: BankParameter[]
  addBankParameterStatus: "idle" | "loading" | "success" | "failure"
  paFlowFilterIsActive: boolean
}

export const TreasuryInitialState: TreasuryState = {
  merchants: [],
  dashboard: {
    to_control: [],
    to_pay: [],
    paid: [],
    rejected: [],
    to_receive: [],
    received: [],
    irrecoverable: [],
  },
  user_available_for_validation: [],
  full_document_history: [],
  merchant_history: [],
  range: allTime,
  paFlowFilterIsActive: true,
  paymentLinkStatus: "idle",
  paymentLinkFullDocumentId: null,
  paymentLinkUrl: null,
  bankParameters: [],
  addBankParameterStatus: "idle",
}

export function TreasuryReducer(
  state = TreasuryInitialState,
  action: TreasuryActionsType
): TreasuryState {
  switch (action.type) {
    case TreasuryActionEnum.GET_TREASURY_MERCHANTS_SUCCESS:
      return {
        ...state,
        merchants: action.payload,
      }
    case TreasuryActionEnum.GET_BUY_FULL_DOCUMENTS_SUCCESS:
      return {
        ...state,
        dashboard: {
          ...TreasuryInitialState.dashboard,
          ...action.payload.dashboard,
        },
      }
    case TreasuryActionEnum.GET_USERS_AVAILAIBLE_FOR_VALIDATION_SUCCESS:
      return {
        ...state,
        user_available_for_validation: action.payload,
      }
    case TreasuryActionEnum.GET_TREASURY_FULL_DOCUMENT_HISTORY_SUCCESS:
      return {
        ...state,
        full_document_history: action.payload,
      }
    case TreasuryActionEnum.GET_TREASURY_FULL_DOCUMENT_HISTORY_FAILURE:
      return {
        ...state,
        full_document_history: [],
      }
    case TreasuryActionEnum.GET_TREASURY_FULL_DOCUMENT_HISTORY_RESET:
      return {
        ...state,
        full_document_history: [],
      }
    case TreasuryActionEnum.GET_TREASURY_MERCHANT_HISTORY_SUCCESS:
      return {
        ...state,
        merchant_history: action.payload,
      }
    case TreasuryActionEnum.GET_TREASURY_MERCHANT_HISTORY_FAILURE:
      return {
        ...state,
        merchant_history: [],
      }
    case TreasuryActionEnum.GET_TREASURY_MERCHANT_HISTORY_RESET:
      return {
        ...state,
        merchant_history: [],
      }
    case TreasuryActionEnum.SET_DATE_RANGE:
      return {
        ...state,
        range: action.payload || allTime,
      }
    case TreasuryActionEnum.SET_PA_FLOW_FILTER:
      return {
        ...state,
        paFlowFilterIsActive: action.payload,
      }
    case TreasuryActionEnum.PAY_FULL_DOCUMENT_ATTEMPT:
      return {
        ...state,
        paymentLinkStatus: "loading",
        paymentLinkUrl: null,
        paymentLinkFullDocumentId: action.payload,
      }
    case TreasuryActionEnum.PAY_FULL_DOCUMENT_SUCCESS:
      return {
        ...state,
        paymentLinkStatus: "success",
        paymentLinkUrl: action.payload,
        paymentLinkFullDocumentId: null,
      }
    case TreasuryActionEnum.PAY_FULL_DOCUMENT_FAILURE:
      return {
        ...state,
        paymentLinkStatus: "failure",
        paymentLinkUrl: null,
        paymentLinkFullDocumentId: null,
      }

    case TreasuryActionEnum.GET_TREASURY_BANK_PARAMETERS_ATTEMPT:
      return {
        ...state,
        bankParameters: [],
      }

    case TreasuryActionEnum.GET_TREASURY_BANK_PARAMETERS_SUCCESS:
      return {
        ...state,
        bankParameters: action.payload,
      }

    case TreasuryActionEnum.GET_TREASURY_BANK_PARAMETERS_FAILURE:
      return {
        ...state,
        bankParameters: [],
      }

    case TreasuryActionEnum.TREASURY_CREATE_BANK_PARAMETERS_FAILURE:
      return {
        ...state,
        addBankParameterStatus: "failure",
      }
    case TreasuryActionEnum.TREASURY_CREATE_BANK_PARAMETERS_RESET:
      return {
        ...state,
        addBankParameterStatus: "idle",
      }
    case TreasuryActionEnum.TREASURY_CREATE_BANK_PARAMETERS_ATTEMPT:
      return {
        ...state,
        addBankParameterStatus: "loading",
      }
    case TreasuryActionEnum.TREASURY_CREATE_BANK_PARAMETERS_SUCCESS:
      return {
        ...state,
        addBankParameterStatus: "success",
      }

    default:
      return { ...state }
  }
}

export const getTreasuryMerchantsThunk =
  (company_id: number) => (dispatch: Dispatch<TreasuryActionsType>) => {
    dispatch(getTreasuryMerchantsAttempt())
    return axios
      .get<TreasuryMerchants[]>(
        `/merchants/get_merchants_treasury_for_company`,
        {
          params: {
            company_id: company_id,
          },
        }
      )
      .then(({ data }) => {
        dispatch(getTreasuryMerchantsSuccess(data))
      })
      .catch((e: AxiosError) => {
        dispatch(getTreasuryMerchantsFailure())
      })
  }

export const askForValidationThunk =
  (
    company_id: number,
    full_document_ids: number[],
    request_user_id: number,
    requested_user_id: number,
    scope: "buy" | "sell"
  ) =>
  (dispatch: Dispatch<TreasuryActionsType | RNBThunkAction>) => {
    dispatch(askForValidationAttempt())
    return axios
      .post(`/full_documents/treasury_request_payment_validation`, {
        company_id,
        full_document_ids,
        request_user_id,
        requested_user_id,
      })
      .then(() => {
        dispatch(askForValidationSuccess())
        dispatch(getTreasuryFullDocumentsThunk(company_id, scope))
      })
      .catch((e) => {
        dispatch(askForValidationFailure(e.response.data.message))
      })
  }

export const getUserAvailableForValidationThunk =
  (company_id: number, amount: number) =>
  (dispatch: Dispatch<TreasuryActionsType>) => {
    dispatch(getUsersAvailableForValidationAttempt())
    return axios
      .get<UsersAvailableForValidation[]>(
        `/user_company_permissions/treasury_users_available_for_validation`,
        {
          params: {
            company_id,
            amount,
          },
        }
      )
      .then(({ data }) => {
        dispatch(getUsersAvailableForValidationSuccess(data))
      })
      .catch((e: AxiosError) => {
        dispatch(getUsersAvailableForValidationFailure())
      })
  }

export const changeMerchantTreasurySettingsThunk =
  (
    merchant_id: number,
    type: string,
    access_action: string,
    company_id: number
  ) =>
  (dispatch: Dispatch<TreasuryActionsType | RNBThunkAction>) => {
    dispatch(changeMerchantTreasurySettingsAttempt())
    return axios
      .put(`/merchants/${merchant_id}/change_merchant_treasury_settings`, {
        type,
        access_action,
        company_id,
      })
      .then(() => {
        dispatch(changeMerchantTreasurySettingsSuccess())
        dispatch(getTreasuryMerchantsThunk(company_id))
      })
      .catch((e) => {
        dispatch(changeMerchantTreasurySettingsFailure(e.response.data.message))
      })
  }

export const getTreasuryFullDocumentsThunk =
  (company_id: number, scope: "buy" | "sell") =>
  (dispatch: Dispatch<TreasuryActionsType>) => {
    dispatch(getTreasuryFullDocumentsAttempt())
    return axios
      .get<getTreasuryFullDocumentsResponse>(
        `/full_documents/get_full_documents_for_treasury`,
        {
          params: {
            company_id,
            scope,
          },
        }
      )
      .then(({ data }) => {
        dispatch(getTreasuryFullDocumentsSuccess(data))
      })
      .catch((e: AxiosError) => {
        dispatch(getTreasuryFullDocumentsFailure())
      })
  }

export const updateFullDocumentPaymentStatusThunk =
  (
    company_id: number,
    full_document_ids: number[],
    access_action: FullDocumentPaymentActionType,
    scope: "buy" | "sell",
    total_amount: number
  ) =>
  (dispatch: Dispatch<TreasuryActionsType | RNBThunkAction>) => {
    dispatch(updateFullDocumentPaymentStatusAttempt())
    return axios
      .post(`/full_documents/treasury_update_payment_status`, {
        full_document_ids,
        access_action,
        total_amount,
        company_id,
      })
      .then(() => {
        dispatch(updateFullDocumentPaymentStatusSuccess())
        dispatch(getTreasuryFullDocumentsThunk(company_id, scope))
      })
      .catch((e) => {
        dispatch(
          updateFullDocumentPaymentStatusFailure(
            e.response.data.message,
            access_action
          )
        )
      })
  }

export const getTreasuryFullDocumentHistoryThunk =
  (full_document_id: number) =>
  (dispatch: Dispatch<TreasuryActionsType | RNBThunkAction>) => {
    dispatch(getTreasuryFullDocumentHistoryReset())
    dispatch(getTreasuryFullDocumentHistoryAttempt())
    return axios
      .get<TreasuryFullDocumentHistory[]>(
        `full_documents/${full_document_id}/get_treasury_full_document_history`
      )
      .then(({ data }) => {
        dispatch(getTreasuryFullDocumentHistorySuccess(data))
      })
      .catch(() => {
        dispatch(getTreasuryFullDocumentHistoryFailure())
      })
  }

export const getTreasuryMerchantHistoryThunk =
  (merchant_id: number) =>
  (dispatch: Dispatch<TreasuryActionsType | RNBThunkAction>) => {
    dispatch(getTreasuryMerchantHistoryAttempt())
    dispatch(getTreasuryMerchantHistoryReset())
    return axios
      .get<TreasuryMerchantHistory[]>(
        `merchants/${merchant_id}/get_merchant_treasury_history`
      )
      .then(({ data }) => {
        dispatch(getTreasuryMerchantHistorySuccess(data))
      })
      .catch(() => {
        dispatch(getTreasuryMerchantHistoryFailure())
      })
  }

export const payFullDocumentThunk =
  ({
    full_document_id,
    iban,
    label,
  }: {
    full_document_id: number
    iban?: string
    label?: string
  }) =>
  (dispatch: Dispatch<TreasuryActionsType | RNBThunkAction>) => {
    dispatch(payFullDocumentAttempt(full_document_id))
    return axios
      .post<{ id: string; url: string }>(
        `full_documents/${full_document_id}/pay`,
        {
          iban,
          label,
        }
      )
      .then(({ data }) => {
        dispatch(payFullDocumentSuccess(data.url))
      })
      .catch(() => {
        dispatch(payFullDocumentFailure())
      })
  }

export interface UserIbanInstruction {
  created_at: string
  instruction_type: "create_iban" | "delete_iban"
  user_email: string
}
interface BankParameter {
  iban_updated_at: null | string
  iban: null | string
  merchant_id: number
  merchant_bank_detail_id: number
  merchant_name: string
  user_iban_instruction_history: Array<UserIbanInstruction>
}
export const getTreasuryBankParametersThunk =
  (company_id: number) =>
  (dispatch: Dispatch<TreasuryActionsType | RNBThunkAction>) => {
    dispatch(getTreasuryBankParametersAttempt())
    return axios
      .get<BankParameter[]>(`full_documents/treasury_bank_parameters`, {
        params: {
          company_id,
        },
      })
      .then(({ data }) => {
        dispatch(getTreasuryBankParametersSuccess(data))
      })
      .catch(() => {
        dispatch(getTreasuryBankParametersFailure())
      })
  }

interface BankParameterPayload {
  iban: string
  merchant_id: number
}
export const treasuryCreateBankParametersThunk =
  ({
    company_id,
    merchant_id,
    iban,
  }: {
    company_id: number
    merchant_id: number
    iban: string
  }) =>
  (dispatch: Dispatch<TreasuryActionsType | RNBThunkAction>) => {
    dispatch(treasuryCreateBankParametersAttempt())
    return axios
      .post<BankParameterPayload>(
        `full_documents/treasury_create_bank_parameters`,
        {
          company_id,
          merchant_id,
          iban,
        }
      )
      .then(({ data }) => {
        dispatch(treasuryCreateBankParametersSuccess())
        dispatch(getTreasuryBankParametersThunk(company_id))
      })
      .catch(() => {
        dispatch(treasuryCreateBankParametersFailure())
      })
  }

export const treasuryDeleteBankParametersThunk =
  ({
    company_id,
    merchant_bank_detail_id,
  }: {
    company_id: number
    merchant_bank_detail_id: number
  }) =>
  (dispatch: Dispatch<TreasuryActionsType | RNBThunkAction>) => {
    dispatch(treasuryDeleteBankParametersAttempt())
    return axios
      .delete<BankParameterPayload>(
        `full_documents/treasury_delete_bank_parameters`,
        {
          params: {
            company_id,
            merchant_bank_detail_id,
          },
        }
      )
      .then(() => {
        dispatch(treasuryDeleteBankParametersSuccess())
        dispatch(getTreasuryBankParametersThunk(company_id))
      })
      .catch(() => {
        dispatch(treasuryDeleteBankParametersFailure())
      })
  }
